/**
 * Renders banner message content (title/message coming from admin-authored banners) as safe HTML.
 * Text is escaped first, then a minimal, whitelisted markdown-like syntax is applied on top
 * (bold with **text** and "- " bullet lists), so no raw HTML/script can be injected via the content.
 */
export function renderBannerContent(content: string): string {
	if (!content) return '';

	const escapeHtml = (text: string) =>
		text
			.replaceAll('&', '&amp;')
			.replaceAll('<', '&lt;')
			.replaceAll('>', '&gt;')
			.replaceAll('"', '&quot;')
			.replaceAll("'", '&#39;');

	const renderInline = (text: string) =>
		escapeHtml(text).replaceAll(/\*\*(.+?)\*\*/g, '<strong>$1</strong>');

	const lines = content.split(/\r?\n/);
	const htmlParts: string[] = [];
	let currentListItems: string[] = [];

	const flushList = () => {
		if (currentListItems.length === 0) return;
		const listItemsHtml = currentListItems.map((item) => `<li>${item}</li>`).join('');
		htmlParts.push(`<ul>${listItemsHtml}</ul>`);
		currentListItems = [];
	};

	for (const rawLine of lines) {
		const line = rawLine.trim();
		if (line.startsWith('- ')) {
			currentListItems.push(renderInline(line.slice(2)));
			continue;
		}
		flushList();
		if (line.length > 0) {
			htmlParts.push(`<p>${renderInline(line)}</p>`);
		}
	}
	flushList();

	return htmlParts.join('');
}
